"use client";

import { home } from "@faire/retailer-visitor-shared/paths/index";
import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpEventTracker } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpEventTracker";
import { useSignUpStepsStore } from "@faire/retailer-visitor-shared/views/SignUp/SignUpStepsContext";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect } from "react";

export const NotifyMeSuccessStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();

  const { trackView, trackSubmit } = useSignUpEventTracker(
    Step.NOTIFY_ME_SUCCESS
  );
  const [, setSignUpStepsStore] = useSignUpStepsStore([]);

  const handleCloseClick = () => {
    trackSubmit();
  };

  useEffect(() => {
    trackView();
  }, [trackView]);

  useEffect(() => {
    setSignUpStepsStore({
      currentStep: Step.NOTIFY_ME_SUCCESS,
    });
  }, [setSignUpStepsStore]);

  return (
    <SignupFormContainer>
      <Column>
        <SignUpTitle
          title={strictLocalize({
            defaultMessage: "You got it! We’ll keep you posted.",
            description: {
              img: "https://cdn.faire.com/fastly/f777f2265c2bd40ec64fecdbe1f30c1778509a0d07866d78d03c7dfdb7069ee1.png",
              text: "Title for the succes step after the user has opted-in to be notified when Faire is available in their country.",
            },
          })}
        />
        <Spacer height="5x" />
        <Button linkTo={home()} replace onClick={handleCloseClick}>
          <StrictLocalMsg
            defaultMessage="Close"
            description={{
              img: "https://cdn.faire.com/fastly/f777f2265c2bd40ec64fecdbe1f30c1778509a0d07866d78d03c7dfdb7069ee1.png",
            }}
          />
        </Button>
      </Column>
    </SignupFormContainer>
  );
};
